function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import withGradient from '../../withGradient';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Index = function Index(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      etc = _objectWithoutProperties(_ref, ["color", "size"]);

  return ___EmotionJSX("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, etc), etc.children, ___EmotionJSX("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28,32 C21.372583,32 16,26.627417 16,20 C16,13.372583 21.372583,8 28,8 C34.627417,8 40,13.372583 40,20 C40,26.627417 34.627417,32 28,32 Z M28,17 C28.8284271,17 29.5,16.3284271 29.5,15.5 C29.5,14.6715729 28.8284271,14 28,14 C27.1715729,14 26.5,14.6715729 26.5,15.5 C26.5,16.3284271 27.1715729,17 28,17 Z M28,26 C28.8284271,26 29.5,25.3284271 29.5,24.5 L29.5,20 L29.4931334,19.85554 C29.4204487,19.0948881 28.7796961,18.5 28,18.5 C27.1715729,18.5 26.5,19.1715729 26.5,20 L26.5,24.5 L26.5068666,24.64446 C26.5795513,25.4051119 27.2203039,26 28,26 Z",
    transform: "translate(-16 -8)"
  }));
};

export default withGradient(Index);